module.exports = __webpack_public_path__ + "img/loading.211e359b.svg";